/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Stack, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

import { ItemContainer, ItemLabel } from "../../../../components/styled";

interface Props {
  items: { label: string; value?: string; testId?: string }[];
  direction?: "row" | "col";
}

const PrintVariants = ({ items, direction = "col" }: Props) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  if (direction === "row") {
    if (items.length === 0) {
      return <></>;
    }
    return (
      <Stack gap={1.25} direction="row">
        {items.map(
          (x) =>
            x.value && (
              <Stack key={x.label}>
                <ItemLabel
                  variant={isSmall ? "body2" : "caption"}
                  textTransform="capitalize"
                  data-testid={x.testId}
                >
                  {x.label}: {x.value}
                </ItemLabel>
              </Stack>
            )
        )}
      </Stack>
    );
  } else {
    return (
      <>
        {items.map(
          (x) =>
            x.value && (
              <ItemContainer wrap={isSmall} key={x.label}>
                <ItemLabel variant={isSmall ? "body2" : "caption"}>{x.label}</ItemLabel>
                <ItemLabel variant="body2" data-testid={x.testId}>
                  {x.value}
                </ItemLabel>
              </ItemContainer>
            )
        )}
      </>
    );
  }
};

export default PrintVariants;
